import React from 'react';
import './Policy.css';

const TermsOfUse: React.FC = () => {
  return (
    <div className="page-container">
      <h2>Terms of Use</h2>
      <p>
        <strong>1. General</strong><br />
        <br />
        <strong>1.1.</strong> These terms apply to the use of the Camplocation App which can be downloaded
        from the Apple App Store and Google Play, and use of the website  <a href="http://camplocation.com" target="_blank" rel="noopener noreferrer">camplocation.com</a>.
        <br />
        <strong>1.2.</strong> The User must read this document carefully.
        <br />
        <strong>1.3.</strong> The App is owned by Dalijus Karvovskis located in Milton Keynes, United Kingdom.
        If you have any questions regarding these Terms of Use, do not hesitate to contact us at <a href="mailto:info@camplocation.com">info@camplocation.com</a>.
      </p>

      <p>
        <strong>2. Applicability and changes</strong><br />
        <br />
        <strong>2.1.</strong> These Terms of Use apply to your use of the App. We have the right to unilaterally change
        these Terms of Use. You will be informed in a timely manner about the changed conditions via an update, either by
        a notification in the App or a message by e-mail.
        <br />
        <strong>2.2.</strong> By using the App you agree to the Terms of Use.
        <br />
        <strong>2.3.</strong> We have the right at any time to adapt the App, change or delete data, limit the use of the
        App or deny access to the App in whole or in part, temporarily or permanently. We will inform you about this
        in a timely and appropriate manner.
      </p>

      <p>
        <strong>3. Use of the App</strong><br />
        <br />
        <strong>3.1.</strong> You are responsible for correct and careful use of the App. You must refrain from
        unauthorized or careless use of the App. In particular you agree to:
        <br />
        <strong>3.1.1.</strong> Fill in the information truthfully.
        <br />
        <strong>3.1.2.</strong> Follow all our instructions for using the App to the best of your abilities.
        <br />
        <strong>3.1.3.</strong> Not to use the App for actions and/or behaviour that conflicts with applicable laws
        or regulations, good morals, public order or rights of third parties. Under no circumstances is it permitted
        to add data, documents or files to the App that have illegal or offensive (including sexist, pornographic,
        racist or discriminatory) content or (otherwise) infringe the privacy and/or rights of third parties.
        <br />
        <strong>3.1.4.</strong> Handle personal login codes confidentially and keep them secret from third parties.
        <br />
        <strong>3.1.5.</strong> Not deliberately cause damage to our good name and reputation.
        <br />
        <strong>3.1.6.</strong> Not to use the App in such a way that it prevents its (correct) functioning,
        breaches security or causes damage to us, the App or third parties.
        <br />
        <strong>3.1.7.</strong> Using this Application to publish, disseminate or otherwise provide content protected
        by intellectual property laws, including but not limited to patent, trademark or copyright law, unlawfully
        and without the legitimate right-holder’s consent.
        <br />
        <strong>3.1.8.</strong> Publishing any content or carrying out any activity that disrupts, interrupts, harms,
        or otherwise violates the integrity of this Application or another User's experience or devices. Such
        activities include: spamming, distributing unauthorized advertisements, phishing, defrauding others,
        spreading malware or viruses etc.
        <br />
        <strong>3.1.9.</strong> Using this Application to publish, disseminate or otherwise make available any other
        content which infringes on any third-party rights, including but not limited to state, military, trade or
        professional secrets and personal data.
        <br />
        <strong>3.1.10.</strong> Registering or using this Application in order to promote, sell or advertise
        products or services of any kind in any way.
        <br />
        <strong>3.2.</strong> If you breach these Terms of Use, we have the right to take any action we deem
        necessary, in our sole discretion, such as suspending or terminating access to the App and/or recovering
        any damages or costs from you.
        <br />
        <strong>3.3.</strong> To use some of the features in the Camplocation App you must create a user account.
        We collect minimal personal information to create a user account, only what is necessary to offer the
        features. There will gradually be more functions where it is necessary to have a user account.
        <br />
        <strong>3.4.</strong> By registering, Users agree to be fully responsible for all activities that occur
        under their username and password. Users are required to immediately and unambiguously inform the Owner
        via the contact details indicated in this document, if they think their personal information, including
        but not limited to User accounts, access credentials or personal data, have been violated, unduly disclosed
        or stolen.
      </p>

      <p>
        <strong>4. Rights</strong><br />
        <br />
        <strong>4.1.</strong> Dalijus Karvovskis is the owner of the Camplocation App and  <a href="http://camplocation.com" target="_blank" rel="noopener noreferrer">camplocation.com</a>, and holds
        all rights to the content and the App and website. The right of use must not be exercised in a way that may be
        in conflict with the App's and website's copyright. The use rights of the App and website lapse immediately
        in the event of a breach of the agreement. Dalijus Karvovskis reserves the right to revoke any right to
        use the App and website. If the right of use is revoked or lapses in any other way, the App must be uninstalled
        and deleted from all devices.
        <br />
        <strong>4.2.</strong> The right to install and use this App, and use the website, is personal, for private use,
        and shall not be passed on to others. The app and website should only be used as it is made and should not
        be modified. The codes and passwords of the App are strictly personal and should not be shared with others.
        <br />
        <strong>4.3.</strong> By installing the App, you agree not to copy the App or use it in any way other than
        for the above purposes. You may not modify or decompile the App, incorporate it into any other application
        outside of its intended purpose or use the App illegally or for any illegal purpose. The same applies for
        use of the website.
      </p>

      <p>
        <strong>5. Account termination</strong><br />
        <br />
        <strong>5.1.</strong> Users can terminate their account and stop using the Service at any time by doing
        the following:
        <br />
        <strong>5.1.1.</strong> By directly contacting the Owner at the contact details provided in this document.
      </p>

      <p>
        <strong>6. Account suspension and deletion</strong><br />
        <br />
        <strong>6.1.</strong> The Owner reserves the right, at its sole discretion, to suspend or delete at any time
        and without notice, User accounts that it deems inappropriate, offensive or in violation of these Terms.
        <br />
        <strong>6.2.</strong> The suspension or deletion of User accounts shall not entitle Users to any claims for
        compensation, damages or reimbursement.
        <br />
        <strong>6.3.</strong> The suspension or deletion of accounts due to causes attributable to the User does not
        exempt the User from paying any applicable fees or prices.
      </p>

      <p>
        <strong>7. Camplocation Extra</strong><br />
        <br />
        <strong>7.1.</strong> Users can purchase additional functionalities by subscribing to “Camplocation extra”.
        <br />
        <strong>7.2.</strong> The Camplocation Extra subscription can be purchased on a monthly or yearly basis. If,
        at any time, we decide to no longer offer the App you will have no right to continue receiving the additional
        services or a (monetary) compensation.
        <br />
        <strong>7.3.</strong> The App and the functionalities of Camplocation Extra are provided as-is. We do not
        guarantee availability.
        <br />
        <strong>7.4.</strong> The functionalities in Camplocation Extra are subject to change. We are constantly
        evolving and improving our services, Camplocation Extra will be adapted accordingly. We have the right to
        add and discontinue functionalities in Camplocation Extra without any prior notice.
      </p>

      <p>
        <strong>8. Limitation of liability</strong><br />
        <br />
        <strong>8.1.</strong> The App and website largely contains information obtained from public sources, such as
        the campsite's website or Google/Facebook page. Camplocation does not take responsibility for any information
        that may be incorrect or altered.
        <br />
        <strong>8.2.</strong> When you contact a campsite or caravan park you make contact on behalf of yourself.
        Camplocation can not guarantee that the campsite or caravan park or other location will respond to your inquiry.
        <br />
        <strong>8.3.</strong> Through this Application Users may have access to external resources provided by
        third parties. Users acknowledge and accept that the Owner has no control over such resources and is
        therefore not responsible for their content and availability.
        <br />
        <strong>8.4.</strong> This Application and the Service may only be used within the scope of what they are
        provided for, under these Terms and applicable law.
        <br />
        <strong>8.5.</strong> Users are solely responsible for making sure that their use of this Application and/or
        the Service violates no applicable law, regulations or third-party rights.
      </p>

      <p>
        <strong>9. Intellectual property rights</strong><br />
        <br />
        <strong>9.1.</strong> All intellectual property rights to the App, including the underlying software, texts,
        images, video and photos, belong solely and exclusively to us or to our licensors.
        <br />
        <strong>9.2.</strong> You hereby grant us a non-exclusive, sub-licensable, transferable, worldwide, irrevocable
        license of use to the data you add to the App.
        <br />
        <strong>9.3.</strong> By granting you access to the App we grant you a revocable, non-exclusive,
        non sub-licensable and non-transferable license to use the App for the purpose formulated by us.
        It is not permitted to use the App for other purposes.
        <br />
        <strong>9.4.</strong> The Owner holds and reserves all intellectual property rights for any such content.
        <br />
        <strong>9.5.</strong> Users may not, therefore, use such content in any way that is not necessary or implicit
        in the proper use of the Service.
        <br />
        <strong>9.6.</strong> In particular, but without limitation, Users may not copy, download, share (beyond the
        limits set forth below), modify, translate, transform, publish, transmit, sell, sublicense, edit,
        transfer/assign to third parties or create derivative works from the content available on this Application,
        nor allow any third party to do so through the User or their device, even without the User's knowledge.
        <br />
        <strong>9.7.</strong> Where explicitly stated on this Application, the User may download, copy and/or share
        some content available through this Application for its sole personal and non-commercial use and provided
        that the copyright attributions and all the other attributions requested by the Owner are correctly
        implemented.
        <br />
        <strong>9.8.</strong> Any applicable statutory limitation or exception to copyright shall stay unaffected.
      </p>

      <p>
        <strong>10. Liability and responsibility</strong><br />
        <br />
        <strong>10.1.</strong> We are never and not in any way liable for damage, injury or other losses resulting
        from your use of the App. You indemnify us against all claims from third parties which are a result of your
        (incorrect) use of the App.
        <br />
        <strong>10.2.</strong> You will remain solely responsible and liable for the decisions you make based on
        the content. This includes, but is not limited to (parking) fines, closed camp sites and damage because
        of incorrect dimensions.
        <br />
        <strong>10.3.</strong> The App’s content is generated by our users, we do not warrant that the content provided
        is complete, current, correct or up to date, nor are we liable for any damage or losses incurred by you relying
        on the content in the App.
      </p>

      <p>
        <strong>11. Content provided by Users</strong><br />
        <br />
        <strong>11.1.</strong> The Owner allows Users to upload, share or provide their own content to this Application.
        <br />
        <strong>11.2.</strong> By providing content to this Application, Users confirm that they are legally allowed
        to do so and that they are not infringing any statutory provisions and/or third-party rights.
        <br />
        <strong>11.3.</strong> Users are solely liable for any content they upload, post, share, or provide
        through this Application.
        <br />
        <strong>11.4.</strong> To the extent permitted by applicable law, Users waive any moral rights in connection
        with content they provide to this Application.
        <br />
        <strong>11.5.</strong> Users acknowledge and accept that the Owner filters or moderates such content after it
        has been made available.
        <br />
        <strong>11.6.</strong> Therefore, the Owner reserves the right to refuse, remove, delete, or block such content
        at its own discretion and to deny access to this Application to the uploading User without prior notice,
        if it considers such content to infringe these Terms, any applicable legal provision or third-party right,
        or to otherwise represent a risk for Users, third parties, the Owner and/or the availability of the Service.
        <br />
        <strong>11.7.</strong> The removal, deletion or blocking of content shall not entitle Users that have provided
        such content or that are liable for it, to any claims for compensation, damages or reimbursement.
        <br />
        <strong>11.8.</strong> Users agree to hold the Owner harmless from and against any claim asserted and/or damage
        suffered due to content they provided to or provided through this Application.
        <br />
        <strong>11.9.</strong> Unless otherwise explicitly stated and without prejudice to applicable law, Users
        shall have no right to claim damages against the Owner (or any natural or legal person acting on its behalf).
      </p>

      <p>
        <strong>12. Service interruption</strong><br />
        <br />
        <strong>12.1.</strong> To ensure the best possible service level, the Owner reserves the right to interrupt
        the Service for maintenance, system updates or any other changes, informing the Users appropriately.
        <br />
        <strong>12.2.</strong> Within the limits of law, the Owner may also decide to suspend or discontinue the
        Service altogether. If the Service is discontinued, the Owner will cooperate with Users to enable them to
        withdraw Personal Data or information.
        <br />
        <strong>12.3.</strong> Additionally, the Service might not be available due to reasons outside the Owner’s
        reasonable control, such as “force majeure” events (infrastructural breakdowns or blackouts etc.).
      </p>

      <p>
        <strong>13. Privacy policy</strong><br />
        <br />
        <strong>13.1.</strong> Read about privacy in our Privacy Policy section.
      </p>

      <p>
        <strong>14. Governing law</strong><br />
        <br />
        <strong>14.1.</strong> These Terms are governed by the law of the place where the Owner is based, as disclosed
        in the relevant section of this document, without regard to conflict of laws principles.
        <br />
        <strong>14.2.</strong> The exclusive competence to decide on any controversy resulting from or connected to
        these Terms lies with the courts of the place where the Owner is based, as displayed in the relevant section
        of this document.
        <br />
        <strong>14.3.</strong> Disputes relating to the App or these Terms of Use will be settled by the competent
        court in the place where we are located, unless mandatory law prescribes a different competent court.
      </p>

      <p>
        <strong>15. Consumer</strong><br />
        <br />
        <strong>15.1.</strong> Consumer is any User qualifying as such under applicable law.
      </p>
    </div>
  );
};

export default TermsOfUse;
